import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiTabContext from '@mui/lab/TabContext';
import MuiTabPanel from '@mui/lab/TabPanel';
import { AppBar as MuiAppBar, Tab as MuiTab, Tabs as MuiTabs, } from '@mui/material';
import { useState } from 'react';
import { styled } from '../../utils';
export function Tabs(props) {
    const { tabs, value, onChange, offset, stickyTop, additionalContent } = props;
    const [currentTabValue, setCurrentTabValue] = useState(value ?? tabs?.[0]?.value);
    const changeTab = (event, selectedValue) => {
        setCurrentTabValue(selectedValue);
        if (onChange) {
            onChange(event, selectedValue);
        }
    };
    return (_jsxs(MuiTabContext, { value: currentTabValue?.toString() ?? '', children: [_jsxs(AppBarStyled, { offset: offset, stickyTop: stickyTop, position: "sticky", children: [_jsx(TabsStyled, { value: currentTabValue, onChange: changeTab, variant: "scrollable", scrollButtons: "auto", children: tabs.map((tab) => (_jsx(TabStyled, { label: tab.text, value: tab.value, disabled: tab.disabled }, tab?.value?.toString()))) }), additionalContent && additionalContent] }), tabs.map((tab) => (_jsx(TabPanelStyled, { offset: offset, value: tab?.value?.toString() ?? '', children: tab.body }, tab?.value?.toString())))] }));
}
const AppBarStyled = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'offset' && prop !== 'stickyTop',
})(({ theme, offset, stickyTop }) => ({
    '& .MuiTabs-scrollButtons': {
        color: theme.palette.primary.dark,
    },
    '& .Mui-disabled': {
        color: theme.palette.action.disabled,
        opacity: '1',
    },
    backgroundColor: theme.palette.primary.contrastText,
    borderBottom: `1px solid ${theme.palette.groupPrimary.lightDove}`,
    boxShadow: 'none',
    zIndex: 2,
    top: '66px',
    ...(stickyTop && {
        top: stickyTop,
    }),
    ...(offset && {
        width: 'unset',
        paddingLeft: theme.spacing(offset),
        paddingRight: theme.spacing(offset),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            paddingLeft: theme.spacing(0),
        },
    }),
}));
const TabPanelStyled = styled(MuiTabPanel, {
    shouldForwardProp: (prop) => prop !== 'offset',
})(({ theme, offset }) => ({
    paddingLeft: 0,
    paddingRight: 0,
    marginLeft: 0,
    marginRight: 0,
    ...(offset && {
        padding: theme.spacing(offset),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(Math.floor(offset / 2)),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(Math.floor(offset / 2) >= 2 ? 2 : Math.floor(offset / 2)),
        },
    }),
}));
const TabsStyled = styled(MuiTabs)(({ theme }) => ({
    '& .MuiTabs-indicator': {
        background: theme.palette.primary.main,
    },
}));
const TabStyled = styled(MuiTab)(({ theme }) => ({
    padding: theme.spacing(2, 2),
    maxWidth: 'unset',
    [theme.breakpoints.down('md')]: {
        fontSize: '0.875rem',
    },
    whiteSpace: 'nowrap',
    color: theme.palette.grey[700],
    opacity: 1,
    fontWeight: theme.typography.fontWeightRegular,
    '& 	.Mui-selected': {
        color: theme.palette.primary.main,
    },
}));
